import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {FunnyItem, IBattle} from "../10. Battle/types";
import Delegate from "../1. Core/Delegate";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import TimeEdit, {TimeEditMode} from "../1. Core/Controls/TimeEdit/TimeEdit";
import WorldTimeEdit from "../1. Core/Controls/TimeEdit/WorldTimeEdit";
import NumField from "../1. Core/Controls/TextField/NumField";
import TextField from "../1. Core/Controls/TextField/TextField";

let moment = require('moment');


export default class EditMMAFunnyDialog extends Dialog {

	private _Event: FunnyItem
	private _Battle: IBattle;
	private EvSaved: Delegate;

	private _time: TimeEdit;
	private _wtime: WorldTimeEdit;
	private _prevSeconds: NumField;
	private _nextSeconds: NumField;
	private descInput: TextField;

	constructor(props: any)
	{
		super(props);
	}


	_initFields(settings: object)
	{
		this._Battle = null;
		this._Event = null;
		this.EvSaved = new Delegate();
		super._initFields(settings);
		this._Caption = NP.RM.getString('EditEvent');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();

		// Action: "Walkout"
		// AthleteId: 8647
		// HLTime: "00:01:11"
		// HighlightDate: "2022-05-28 12:32:22"
		// HighlightTS: "2022-05-28 12:32:22.922+0000"
		// Id: 4060
		// Round: 1

		switch (this._Event.Action)
		{
			case "Walkout":
			case "Stat":
			case "Staredown":
			case "ShowRespect":
			case "ToT":
			case "Winning":
				break;
			default:
				this.descInput = new TextField({
					ParentNode: this._contentNode,
					Width: 379,
					Value: this._Event.Action,
					FloatingLabel: NP.RM.getString('Action')
				});
				break;
		}

		this._time = new TimeEdit({
			FloatingLabel: 'Time',
			ParentNode: this._contentNode,
			Width: 379,
			Data: 'Time',
			Mode: TimeEditMode.Full,
			Value: this._Event.HLTime,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._wtime.incrementValue(e.IsPlus, false)
			}
		})

		this._wtime = new WorldTimeEdit({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('WorldTime'),
			Width: 379,
			Data: 'ActionTS',
			Value: moment(this._Event.HighlightDate, 'YYYY-MM-DD HH:mm:ss.SSS').toDate(),
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._time.incrementValue(e.IsPlus, false)
			}
		})


		let info = this._Event.TimeInfo;

		if (info)
		{
			this._prevSeconds = new NumField({
				ParentNode: this._contentNode,
				Min: 0,
				Max: 50,
				Width: 190,
				SpinEdit: true,
				Value: info.PrevSeconds,
				FloatingLabel: NP.RM.getString('PrevSec')
			});

			this._nextSeconds = new NumField({
				ParentNode: this._contentNode,
				Min: 0,
				Max: 50,
				Width: 190,
				SpinEdit: true,
				Value: info.NextSeconds,
				FloatingLabel: NP.RM.getString('NextSec')
			});
		}
	}


	async _onOkButtonClick()
	{
		this._Event.HLTime = this._time.getValue();
		this._Event.HighlightDate = this._wtime.getValue()
		this._Event.HighlightTS = this._wtime.getValue() + "+0000"

		if (this.descInput)
			this._Event.Action = this.descInput.getValue();

		let info = this._Event.TimeInfo;
		if (info)
		{
			info.NextSeconds = this._nextSeconds.getValue();
			info.PrevSeconds = this._prevSeconds.getValue();
		}

		await ServerAPI.post('/highlight/updateHighlightFunny', this._Event);

		this.EvSaved.fire(this);
		this.hide();
	}

}